import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getAllActiveCategory: builder.mutation({
            query: (body) => ({
                url: `category/getAllActiveCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        addDropdown: builder.mutation({
            query: (body) => ({
                url: `dropdown/addDropdown`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllDropdown: builder.mutation({
            query: (body) => ({
                url: `dropdown/getAllDropdown`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getDropdown: builder.mutation({
            query: (body) => ({
                url: `dropdown/getDropdownById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllActiveDropdown: builder.mutation({
            query: (body) => ({
                url: `dropdown/getAllActiveDropdown`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        updateDropdown: builder.mutation({
            query: (body) => ({
                url: `dropdown/updateDropdown`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getCategoryDropdown: builder.mutation({
            query: (body) => ({
                url: `category/getCategory`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getAllCategoryForDropdown: builder.mutation({
            query: (body) => ({
                url: `category/getAllCategoryForDropdown`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useGetAllActiveCategoryMutation, useAddDropdownMutation, useGetAllDropdownMutation, useGetDropdownMutation, useUpdateDropdownMutation, useGetCategoryDropdownMutation, useGetAllCategoryForDropdownMutation , useGetAllActiveDropdownMutation } = Api
